import React from 'react';

import {defaultTheme} from '@stencil/build-theme';

import HappyCoupleFriendlyIcon from '@stencil/icons/src/HappyCoupleFriendlyIconv2/HappyCoupleFriendlyIconv2';
import HappyOyoIcon from '@stencil/icons/src/HappyOyoIcon/HappyOyoIcon';
import HappyGoSafeLogo from '@stencil/icons/src/HappyGoSafeLogo/HappyGoSafeLogo';
import HappyHotelSearchIcon from '@stencil/icons/src/HappyHotelSearchIcon/HappyHotelSearchIcon';
import HappyGostayIcon from '@stencil/icons/src/HappyGostayIcon/HappyGostayIcon';

// import ActiveGosafeTabIcon from '../../stories/Icons/Amenities/ActiveGosafeTab';
// import InactiveGosafeTab from '../../stories/Icons/Amenities/InactiveGosafeTab';

// this is binded to flti for icon selection from Hermes response in
// city_meta_info which is always to be in sync with flt for tabsList
const TabsIconSelector = ({name, isActive, ...styleProps}) => {
  switch (name) {
    case 'tGostay':
      return <HappyGostayIcon {...styleProps} isActive={isActive} />;
    case 'tCoupleFriendly':
      return <HappyCoupleFriendlyIcon {...styleProps} isActive={isActive} />;
    case 'tOyo':
      return <HappyOyoIcon {...styleProps} isActive={isActive} />;
    // case 'tGosafe':
    //   return isActive ? (
    //     <ActiveGosafeTabIcon {...styleProps} />
    //   ) : (
    //     <InactiveGosafeTab {...styleProps} />
    //   );
    case 'tGosafe':
      return <HappyGoSafeLogo {...styleProps} />;
    default:
      return (
        <HappyHotelSearchIcon
          // fill={defaultTheme.colors.downriver.medium}
          isActive={isActive}
          {...styleProps}
        />
      );
  }
};

export default TabsIconSelector;
